<template>
  <Form>
    <div class="create-profile-wrapper">
      <div class="form-progress-wrap edit-profile basic-info-wrap">
        <div class="container">
          <div class="steps-content">
            <div class="general-form-wrap player-detail-form-wrap box-wrapper">
              <div class="heading">
                <h2 class="form-title">
                  {{
                    workingTypeNew
                      ? "Add New Highlight"
                      : `${highlight.title} Details Edit`
                  }}
                </h2>
              </div>
              <div class="coach-edit-form">
                <BaseDragUpload
                  cannot-delete
                  class="drag-image-wrapper"
                  label="Click this area to upload or change photo"
                  @file-upload="
                    image => {
                      imageSrc = image;
                    }
                  "
                  :imageUrl="imageUrl"
                />
                <FormItem class="relative-position-coach">
                  <FormModel
                    class="highlight-form-wrapper"
                    :model="highlight"
                    :rules="validationRules"
                    ref="form"
                    @submit.prevent.native="handleFormSubmit"
                  >
                    <a-row :gutter="32">
                      <a-col :sm="24">
                        <BaseFormInput
                          :value="highlight.title"
                          label="Title"
                          placeholder="Enter Title"
                          @change="
                            event => handleFormValueChange(event, 'title')
                          "
                          name="title"
                        />
                      </a-col>
                      <a-col :sm="24">
                        <BaseFormInput
                          :value="highlight.description"
                          label="Description"
                          placeholder="Enter Description"
                          @change="
                            event => handleFormValueChange(event, 'description')
                          "
                          name="description"
                          type="textarea"
                        />
                      </a-col>
                      <a-col :sm="24" :md="12">
                        <BaseFormInput
                          :value="highlight.videoDesc1"
                          label="Video 1 Title"
                          placeholder="Enter Video Title"
                          @change="
                            event => handleFormValueChange(event, 'videoDesc1')
                          "
                        />
                      </a-col>
                      <a-col :sm="24" :md="12">
                        <BaseFormInput
                          :value="highlight.video1"
                          label="Video 1 URL"
                          placeholder="Enter video url"
                          @change="
                            event => handleFormValueChange(event, 'video1')
                          "
                        />
                      </a-col>
                      <a-col :sm="24" :md="12">
                        <BaseFormInput
                          :value="highlight.videoDesc2"
                          label="Video 2 Title"
                          placeholder="Enter Second video Title"
                          @change="
                            event => handleFormValueChange(event, 'videoDesc2')
                          "
                        />
                      </a-col>
                      <a-col :sm="24" :md="12">
                        <BaseFormInput
                          :value="highlight.video2"
                          label="Video 2 URL"
                          placeholder="Enter second video url"
                          @change="
                            event => handleFormValueChange(event, 'video2')
                          "
                        />
                      </a-col>
                    </a-row>
                    <div class="footer-button-wrapper">
                      <div class="submit-button">
                        <BaseButton
                          type="primary"
                          html-type="submit"
                          :disabled="Boolean(!imageSrc && !imageUrl)"
                          :loading="clubTeamHighlightLoading"
                        >
                          {{ workingTypeEdit ? "Update" : "Create New" }}
                        </BaseButton>
                      </div>
                      <div class="extra-buttons">
                        <BaseButton
                          type="danger"
                          @click="backToList"
                          class="first-child-wrapper"
                          :loading="clubTeamHighlightLoading"
                        >
                          Back to List
                        </BaseButton>
                      </div>
                    </div>
                  </FormModel>
                </FormItem>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Form>
</template>

<script>
import { Form, FormModel } from "ant-design-vue";
import { ClubTeamHighlight } from "@/models";
import { mapGetters } from "vuex";

const FormItem = FormModel.Item;
const CLUB_TEAM_HIGHLIGHT_STORE = "clubTeamHighlightStore";

export default {
  data() {
    return {
      highlight: new ClubTeamHighlight(this.resource),
      validationRules: {
        title: [{ required: true, message: "Title is required" }]
      },
      imageSrc: "",
      imageUrl: ""
    };
  },
  components: {
    Form,
    FormModel,
    FormItem
  },
  props: {
    workingType: {
      type: String,
      default: "new"
    },
    resource: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({
      clubTeamHighlight: `${CLUB_TEAM_HIGHLIGHT_STORE}/clubTeamHighlight`,
      clubTeamHighlightLoading: `${CLUB_TEAM_HIGHLIGHT_STORE}/clubTeamHighlightLoading`,
      clubTeamHighlightsLoading: `${CLUB_TEAM_HIGHLIGHT_STORE}/clubTeamHighlightsLoading`
    }),
    workingTypeNew() {
      return this.workingType === "new";
    },
    clubId() {
      return localStorage["club-id"];
    },
    profileId() {
      return ClubTeamHighlight.profileId();
    },
    workingTypeEdit() {
      return this.workingType === "edit";
    }
  },
  methods: {
    async newFormSubmit() {
      if (!this.imageSrc) return;
      this.$refs.form.validate(async valid => {
        if (valid) {
          await this.$store.dispatch(
            `${CLUB_TEAM_HIGHLIGHT_STORE}/createClubTeamHighlights`,
            {
              title: this.highlight.title,
              clubId: this.clubId,
              description: this.highlight.description,
              video1: this.highlight.video1,
              video2: this.highlight.video2,
              videoDesc1: this.highlight.videoDesc1,
              videoDesc2: this.highlight.videoDesc2,
              slug: "clubhighlight"
            }
          );
          let formData = new FormData();
          formData.append("file", this.imageSrc);
          this.imageSrc &&
            (await this.$store.dispatch(
              `${CLUB_TEAM_HIGHLIGHT_STORE}/updateImageForHighlight`,
              {
                id: this.clubTeamHighlight.id,
                image: formData
              }
            ));
          this.backToList();
        }
      });
    },
    async updateFormSubmit() {
      await this.$refs.form.validate(async valid => {
        if (valid) {
          await this.$store.dispatch(
            `${CLUB_TEAM_HIGHLIGHT_STORE}/updateClubTeamHighlights`,
            {
              id: this.highlight.id,
              title: this.highlight.title,
              description: this.highlight.description,
              video1: this.highlight.video1,
              clubId: this.clubId,
              video2: this.highlight.video2,
              videoDesc1: this.highlight.videoDesc1,
              videoDesc2: this.highlight.videoDesc2,
              slug: "clubhighlight"
            }
          );
          let formData = new FormData();
          formData.append("file", this.imageSrc);
          this.imageSrc &&
            (await this.$store.dispatch(
              `${CLUB_TEAM_HIGHLIGHT_STORE}/updateImageForHighlight`,
              {
                id: this.highlight.id,
                image: formData
              }
            ));
          this.backToList();
        }
      });
    },
    backToList() {
      this.$router.push(`/${this.profileId}/club_profile/team_highlights`);
    },
    handleFormSubmit() {
      this.workingTypeNew ? this.newFormSubmit() : this.updateFormSubmit();
    },
    handleFormValueChange(e, key) {
      this.highlight = new ClubTeamHighlight({
        ...this.highlight,
        [key]: e.target.value
      });
    }
  },
  watch: {
    resource(newVal) {
      this.highlight = new ClubTeamHighlight(this.resource);
      this.imageUrl = newVal.image;
    }
  }
};
</script>

<style lang="sass"></style>
